import { render } from "./SearchForm.vue?vue&type=template&id=58fcb1b8&scoped=true"
import script from "./SearchForm.vue?vue&type=script&lang=js"
export * from "./SearchForm.vue?vue&type=script&lang=js"

import "./SearchForm.vue?vue&type=style&index=0&id=58fcb1b8&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-58fcb1b8"

export default script